module.exports = {"371681001":"黛溪街道","371681002":"黄山街道","371681003":"高新街道","371681004":"好生街道","371681005":"西董街道","371681101":"长山镇","371681102":"魏桥镇","371681105":"临池镇","371681108":"焦桥镇","371681109":"韩店镇","371681110":"孙镇镇","371681111":"九户镇","371681112":"青阳镇","371681113":"明集镇","371681114":"台子镇","371681115":"码头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371681.json
// module id = 1500
// module chunks = 0